import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { CoreModule } from '@core/core.module';

import { FooterComponent } from '@layout/footer/footer.component';
import { HeaderComponent } from '@layout/header/header.component';
import { MainpageComponent } from '@layout/mainpage/mainpage.component';

import { SharedModule } from '@shared/shared.module';
import { LocationStrategy, PathLocationStrategy } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { apiService } from './services/api.service';


import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClientModule, HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from "rxjs";
import { environment } from "environments/environment";
import { ButtonsModule } from 'ngx-bootstrap/buttons';
import { ModalModule } from 'ngx-bootstrap/modal';
import { CustomModalComponent } from '@shared/custom-modal/custom-modal.component';
import { CreateNewAccountComponent } from '@shared/create-new-account/create-new-account.component';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { DisabledAutocompleteModule } from '@ngx-ext/disabled-autocomplete';
import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { AuthModule } from './auth/auth/auth.module';
import { B2cGlobalDataService } from './services/b2cGlobalData.service';



export class CustomLoader implements TranslateLoader  {
  constructor(private httpClient: HttpClient) {}
  getTranslation(lang: string): Observable<any> {
    const header = new HttpHeaders({
     'Content-Type': 'application/json',
     'Access-Control-Allow-Origin': '*',
    });
    const apiAddress = environment.API_BASE_URL+'/storage/locale/b2c/'+lang+'.json';
    return this.httpClient.get(apiAddress);
  }
}

@NgModule({
  declarations: [
    AppComponent,
    MainpageComponent,
    HeaderComponent,
    FooterComponent,
    CustomModalComponent,
    CreateNewAccountComponent,
  ],
  imports: [
    NgxSliderModule,
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    DisabledAutocompleteModule,
    CoreModule,
    SharedModule,
    FontAwesomeModule,
    AuthModule,
    TabsModule.forRoot(),
    ModalModule.forRoot(),
    ButtonsModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useClass: CustomLoader, // USE THIS FOR API
        deps: [HttpClient]
      }
    })
  ],
  providers: [apiService,B2cGlobalDataService,{
    provide: LocationStrategy,
    useClass: PathLocationStrategy
           }],
  bootstrap: [AppComponent],
})
export class AppModule { }

